import { PortfolioDTO, PortfolioItemDTO } from 'csr-asset-app';

/**
 * Maps a PortfolioItemDTO to a PortfolioDTO
 * @param portfolio The portfolio item to map
 * @returns Mapped PortfolioDTO
 */
export function mapToPortfolioDTO(portfolio: PortfolioItemDTO): PortfolioDTO {
  return {
    id: portfolio.id,
    code: portfolio.code,
    name: portfolio.name,
    businessKey: portfolio.businessKey,
    kfcCode: portfolio.kfcCode,
    isDemoPortfolio: portfolio.demoPortfolio,
    resetOnRecalculate: false,
    autoUpdateCharacteristics: false,
    importUploadDisabled: portfolio.importUploadDisabled === true,
    autoImplementMeasures: false
  };
}
